module.exports = __webpack_public_path__ + "img/2.19819fc5.png";